module.exports = __webpack_public_path__ + "6abccf21232fb41b30be1635714b37e8.pdf";